import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { createQuoteMember } from "../QuoteService";
import { showToast } from "../../../../common/Toaster/Toaster";
import { useQuoteAgList } from "./useQuoteOptions";

// Creates an AG member from the Convert to Order flow. The server looks the AG
// up by organization id, so the member must be created under the selected AG
// organization, not the logged-in user organization.
const useCreateQuoteMember = () => {
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const formState = useSelector((state) => state.common.formRendererState);
  const detailsData = useSelector(
    (state) => state.order.selectedOrders.detailsData
  );
  const { data: agList = [] } = useQuoteAgList(selectedUser.organizationid);

  const agId = detailsData.ag_id || formState.ag_id;
  const agOrganizationId = agList.find(
    (item) => String(item.entityid) === String(agId)
  )?.organizationid;

  return useMutation({
    mutationFn: (member) => {
      if (!agOrganizationId) {
        return Promise.reject(
          new Error("Select an AG on the Details tab before adding a member")
        );
      }
      return createQuoteMember(member, agOrganizationId);
    },
    onSuccess: () => {
      showToast("Member added successfully", "success");
    },
    onError: (error) => {
      showToast(
        error?.response?.data?.error_message ||
          error?.message ||
          "Error while adding member",
        "error"
      );
    },
  });
};

export default useCreateQuoteMember;
